import { memo } from 'react';
import { Box, Typography } from '@mui/material';

import { FORTA_BLACK, FORTA_ERROR } from '../../../../../../../../../utils/colors';
import AttentionIcon from '../../../../../../../../../assets/images/attention.svg';

interface TimeTooltipTitleProps {
  startBetween10to12: boolean;
  endBetween10to12: boolean;
  isTZIdentified: boolean;
  abbreviatedZone: string;
}

function TimeTooltipTitle({
  startBetween10to12,
  endBetween10to12,
  isTZIdentified,
  abbreviatedZone,
}: TimeTooltipTitleProps) {
  return (
    <Box data-testid="tooltipTitle" sx={{ display: 'flex', alignItems: 'center' }}>
      <img
        style={{
          width: '20px',
          height: '20px',
          marginRight: '8px',
          marginTop: '-4px',
          filter: 'brightness(84%) contrast(189%) hue-rotate(145deg) saturate(300%)',
        }}
        src={AttentionIcon}
        alt="attention-icon"
      />
      {startBetween10to12 || endBetween10to12 ? (
        <Typography sx={{ fontSize: '16px', color: FORTA_BLACK }}>
          Attention: Supervisions conducted between{' '}
          <b>
            <span style={{ color: FORTA_ERROR }}>{`10:00 p.m and 12:00 a.m ${
              isTZIdentified ? `in the client's local time zone (${abbreviatedZone})` : ''
            } `}</span>
            are unlikely to be accepted by the insurance.
          </b>
        </Typography>
      ) : (
        <Typography sx={{ fontSize: '16px', color: FORTA_BLACK }}>
          Attention: Supervisions conducted between{' '}
          <b>
            <span style={{ color: FORTA_ERROR }}>{`12:00 a.m and 4:00 a.m ${
              isTZIdentified ? `in the client's local time zone (${abbreviatedZone}) ` : ''
            } `}</span>
            will not be accepted by the insurance.
          </b>
        </Typography>
      )}
    </Box>
  );
}

export default memo(TimeTooltipTitle);
